import { hashTypedData } from 'viem';
export const domainHash = (message) => {
    const typedData = {
        domain: message.domain,
        types: message.types,
        primaryType: 'EIP712Domain',
        message: message.domain,
    };
    return hashTypedData(typedData);
};
export const messageHash = (message) => {
    const typedData = {
        domain: message.domain,
        types: message.types,
        primaryType: message.primaryType,
        message: message.message,
    };
    return hashTypedData(typedData);
};
